import styled from 'styled-components';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { LANDING_IMAGES } from '../landingAssets';
import LandingArrow from './LandingArrow';

const LandingHeroStyled = styled.section``;

function LandingHero({ onOpenContact }) {
    const { getLangPath } = useLangContext();

    return (
        <LandingHeroStyled className="hero wrap" id="audience">
            <div className="hero-grid">
                <div>
                    <h1>
                        <span>{getLangPath('landing.hero.line1')}</span>
                        <span>{getLangPath('landing.hero.line2')}</span>
                        <span className="mobile-hero-title">
                            {getLangPath('landing.hero.mobileLine1')}
                            <br/>
                            {getLangPath('landing.hero.mobileLine2')}
                            <br/>
                            {getLangPath('landing.hero.mobileLine3')}
                        </span>
                    </h1>
                    <p>{getLangPath('landing.hero.text')}</p>
                </div>
                <div className="hero-people">
                    <img
                        src={LANDING_IMAGES.communityHero}
                        alt={getLangPath('landing.hero.imageAlt')}
                        width="1920"
                        height="531"
                    />
                </div>
                <div className="hero-action">
                    <button className="btn" type="button" aria-haspopup="dialog" aria-controls="contact" onClick={onOpenContact}>
                        {getLangPath('landing.hero.cta')}
                        {' '}
                        <LandingArrow/>
                    </button>
                </div>
            </div>
        </LandingHeroStyled>
    );
}

export default LandingHero;
